import React from 'react';
import { MagnifyingGlassIcon } from '@heroicons/react/24/outline';
import { useTheme } from '../contexts/ThemeContext';

interface SearchInputProps {
  value: string;
  onChange: (value: string) => void;
  onSubmit?: () => void;
  placeholder?: string;
  className?: string;
}

const SearchInput: React.FC<SearchInputProps> = ({
  value,
  onChange,
  onSubmit,
  placeholder = 'Pesquise...',
  className = ''
}) => {
  const { isDark } = useTheme();

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    if (onSubmit) {
      onSubmit();
    }
  };

  return (
    <form onSubmit={handleSubmit} className={className}>
      <div className="relative flex items-center">
        <div className={`absolute left-0 pl-3 flex items-center pointer-events-none ${
          isDark ? 'text-gray-300' : 'text-gray-500'
        }`}>
          <MagnifyingGlassIcon className="h-5 w-5" />
        </div>
        <input
          type="text"
          value={value}
          onChange={(e) => onChange(e.target.value)}
          placeholder={placeholder}
          className={`w-full pl-10 pr-4 py-2.5 sm:py-3 text-sm sm:text-base rounded-lg border ${
            isDark 
              ? 'bg-gray-700 border-gray-600 text-white placeholder-gray-400' 
              : 'bg-white border-gray-300 text-gray-900 placeholder-gray-500'
          } focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-colors`}
          style={{ paddingLeft: '2.5rem' }}
        />
      </div>
    </form>
  );
};

export default SearchInput;
